import * as defaultData from "utilities/community/update-phone-based-on-zip-utility/1.0.0/js/default-common-data";
/*-----------------------------------------------------------------

utility: update-phone-based-on-zip-utility
author: Chuck Rapp && Don Knapp


# Updates phone number if zip code is set between a range of zip codes 

-----------------------------------------------------------------*/

const importData = defaultData.default;
const pilotPagesToUpdate = importData.pittsTFN.pageID;
const zipLow = importData.pittsTFN.zipLow;
const zipHigh = importData.pittsTFN.zipHigh;
const phone = importData.pittsTFN.phone;

let spartaGetCookie = function(name) {
  let returnvalue = '';
  const search = `${name}=`;

  if (document.cookie.length > 0) {
    let offset = document.cookie.indexOf(search);
    if (offset !== -1) {
      offset += search.length;
      let end = document.cookie.indexOf(';', offset);
      if (end === -1) {
        end = document.cookie.length;
      }
      returnvalue = unescape(document.cookie.substring(offset, end));
    }
  }
  return returnvalue;
}

const currentPage = spaParams.siteName + "/" + (spaParams.pageParams.pageID || ""); //grab current site/page ID
const currentZip = spartaGetCookie("boa_geographic_data"); // grab the cookie
const trimmedZip = currentZip.split("|")[0]; // trim to just 5 digit zip code

class UpdatePhoneOnZip {

  

  checkPageAgainstPilot() {
    if (trimmedZip >= zipLow && trimmedZip <= zipHigh) {
      const pageFound = pilotPagesToUpdate.find( function(e) {
        return e === currentPage;
      });

      if (!pageFound) return;

      const numberToUpdate = document.getElementsByClassName('dynamic-phone');
      const mobileNumberToUpdate = document.getElementsByClassName('dynamic-phone-mobile');

      Array.prototype.forEach.call(numberToUpdate, function(el) {
        el.innerHTML = phone;
      });
      
      Array.prototype.forEach.call(mobileNumberToUpdate, function(el) {
        el.href = "tel:" + phone;
      });
    }
  }
}

export default new UpdatePhoneOnZip();
